import React from 'react';
// Simplified MultiSelect for prototype (native select with multiple)
// In production, use a library like react-select or headless UI combobox
interface MultiSelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  label?: string;
  error?: string;
  options: {
    value: string;
    label: string;
  }[];
  description?: string;
  fullWidth?: boolean;
}
export function MultiSelect({
  label,
  error,
  options,
  className = '',
  id,
  description,
  fullWidth = true,
  ...props
}: MultiSelectProps) {
  const selectId = id || props.name || Math.random().toString(36).substr(2, 9);
  return <div className={`${fullWidth ? 'w-full' : ''} flex flex-col gap-1.5`} data-id="element-465">
      {label && <label htmlFor={selectId} className="block text-sm font-medium text-slate-700" data-id="element-466">
          {label} {props.required && <span className="text-red-500" data-id="element-467">*</span>}
        </label>}
      <select id={selectId} multiple className={`
          block w-full rounded-xl border-2 border-slate-200 bg-slate-50/50 
          px-4 py-2.5 text-sm transition-all duration-200
          focus:border-seform-orange focus:bg-white focus:ring-0 focus:outline-none
          disabled:bg-slate-100 disabled:text-slate-500
          ${error ? 'border-red-300 focus:border-red-500' : 'hover:border-slate-300'}
          ${className}
        `} {...props} data-id="element-468">
        {options.map(opt => <option key={opt.value} value={opt.value} data-id="element-469">
            {opt.label}
          </option>)}
      </select>
      <p className="text-[10px] text-slate-400" data-id="element-470">
        Tieni premuto Ctrl (o Cmd) per selezionare più opzioni
      </p>
      {description && !error && <p className="text-xs text-slate-500" data-id="element-471">{description}</p>}
      {error && <p className="text-xs text-red-600 font-medium" data-id="element-472">{error}</p>}
    </div>;
}